import { DialogBase } from '@scale/dialog-base';
import { DrawerOpenEvent, DrawerCloseEvent } from '@scale/events';

class ScaleDrawer extends DialogBase {
  get useHistory() {
    return true;
  }

  get swipeToClose() {
    return true;
  }

  setupDialog() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.ref('dialog').open) {
        e.preventDefault();
        this.close();
      }
    }, { signal: this.signal });
  }

  onDialogOpen() {
    this.broadcast(new DrawerOpenEvent(this.id));
  }

  onDialogClose() {
    this.broadcast(new DrawerCloseEvent(this.id));
  }
}

if (!customElements.get('scale-drawer')) {
  customElements.define('scale-drawer', ScaleDrawer);
}
